import { createIcon } from "@chakra-xui/icon"
import * as React from "react"

export const MinusIcon = createIcon({
  displayName: "MinusIcon",
  path: (
    <g fill="currentColor">
      <rect height="4" width="20" x="2" y="10" />
    </g>
  ),
})
